export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9713.d57e92fa.jpg";